<script>
export default {
  props: {
    visible: {
      type: Boolean
    },
    body: {
      type: Boolean,
      default: false
    },
    top: {},
    bottom: {},
    mask: {
      type: Boolean,
      default: false
    },
    lockScroll: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      render: this.$props.visible
    }
  },
  computed: {
    posStyle () {
      const style = {}
      this.top && (style.top = this.top)
      this.bottom && (style.bottom = this.bottom)
      return style
    },
    headerbarHeight () {
      let parent = this.$parent
      while (parent !== parent.$parent && parent.$options.name !== 'page') {
        parent = parent.$parent
      }
      return parent.headerbarHeight || '0px'
    },
    maskStyle () {
      if (this.mask) {
        return {
          'background-color': 'rgba(0, 0, 0, .5)'
        }
      } else {
        return ''
      }
    }
  },
  watch: {
    visible (newVal) {
      if (newVal) {
        this.render = newVal
        if (this.body) {
          document.body.appendChild(this.$el)
        }
        if (this.lockScroll) {
          document.body.style.overflow = 'hidden'
        }
      } else {
        if (this.lockScroll) {
          document.body.style.overflow = 'visible'
        }
      }
    }
  },
  methods: {
    show () {
      this.$emit('show')
    },
    hide () {
      this.$emit('hide')
    }
  },
  mounted () {
    if (this.body) {
      document.body.appendChild(this.$el)
    }
  },
  beforeDestroy () {
    document.body.style.overflow = 'visible'
    if (this.body && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>

<template>
  <div class="dialog_wrapper" v-show="visible" v-if="render" >
    <div class="dialog_mask" @click.stop="hide" :style="maskStyle"></div>
    <div class="dialog_content" :style="{top: headerbarHeight, height: `calc(100% - ${headerbarHeight}`}">
      <slot />
    </div>
  </div>
</template>

<style lang="stylus">
.dialog_wrapper
  position fixed
  width 100%
  height 100%
  z-index 110
  top 0
.dialog_mask
  position absolute
  width 100%
  height 100%
.dialog_content
  position absolute
  width 100%
  overflow-y auto
</style>
